var _path, _path2, _g, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGotoAdminWhiteYellow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 141,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M94.34 19 89.22 5H85.3l-5.12 14h2.26l1.2-3.38h7.14l1.2 3.38zM87.22 5.64l2.84 8h-5.7zM103.503 11.74c-.64-1.9-2.12-3.16-4.06-3.16-2.64 0-4.62 2.3-4.62 5.32 0 3 1.98 5.3 4.62 5.3 1.94 0 3.42-1.26 4.06-3.16V19h2.1V4.2h-2.1zm-3.36 5.52c-1.74 0-3.16-1.44-3.16-3.36 0-1.94 1.42-3.38 3.16-3.38 1.96 0 3.36 1.44 3.36 3.38 0 1.92-1.4 3.36-3.36 3.36M120.077 8.58c-1.64 0-2.92 1.12-3.4 2.84-.46-1.7-1.7-2.84-3.36-2.84-1.54 0-2.72 1.06-3.26 2.7v-2.5h-2.1V19h2.1v-5.78c0-1.58 1.02-2.72 2.46-2.72 1.26 0 2.24 1.14 2.24 2.72V19h2.1v-5.78c0-1.58 1.02-2.72 2.46-2.72 1.26 0 2.26 1.14 2.26 2.72V19h2.1v-6.1c0-2.5-1.48-4.32-3.6-4.32M125.686 5.84c0 .72.6 1.3 1.32 1.3s1.3-.58 1.3-1.3-.58-1.3-1.3-1.3-1.32.58-1.32 1.3m2.36 13.16V8.78h-2.1V19zM136.159 8.58c-1.76 0-3.1 1.1-3.66 2.84V8.78h-2.1V19h2.1v-5.78c0-1.58 1.18-2.72 2.86-2.72 1.48 0 2.64 1.14 2.64 2.72V19h2.1v-6.1c0-2.5-1.6-4.32-3.94-4.32"
})), /*#__PURE__*/React.createElement("mask", {
  id: "goto_admin_White_Yellow_svg__a",
  width: 65,
  height: 15,
  x: 0,
  y: 17,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 17.907h65v14.092H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#goto_admin_White_Yellow_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFE900",
  fillRule: "evenodd",
  d: "M.77 31.999 65 25.263l-.775-7.356-64.229 6.736z",
  clipRule: "evenodd"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M31.126 15.615a4.115 4.115 0 0 1-4.117-4.11 4.115 4.115 0 0 1 4.117-4.109 4.115 4.115 0 0 1 4.118 4.11 4.115 4.115 0 0 1-4.118 4.108m0-11.506c-4.085 0-7.412 3.287-7.412 7.397 0 4.076 3.328 7.396 7.412 7.396a7.394 7.394 0 0 0 7.412-7.397 7.373 7.373 0 0 0-7.412-7.396M54.98 15.615a4.115 4.115 0 0 1-4.118-4.11 4.115 4.115 0 0 1 4.118-4.109 4.115 4.115 0 0 1 4.118 4.11 4.115 4.115 0 0 1-4.118 4.108m0-11.506c-4.085 0-7.412 3.287-7.412 7.397 0 4.076 3.327 7.396 7.412 7.396a7.394 7.394 0 0 0 7.412-7.397 7.373 7.373 0 0 0-7.412-7.396",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M50.465 3.681V.395H35.641V3.68h5.764v14.826H44.7V3.68zM11.098 7.79v3.288h4.552c-1.05 2.755-3.054 4.537-5.376 4.537a6.16 6.16 0 0 1-4.348-1.809 6.15 6.15 0 0 1-1.812-4.372c0-1.709.692-3.221 1.812-4.339a6.16 6.16 0 0 1 4.348-1.808 6.18 6.18 0 0 1 4.381 1.808l2.34-2.334A9.47 9.47 0 0 0 10.273 0a9.45 9.45 0 0 0-6.687 2.761A9.4 9.4 0 0 0 .82 9.434a9.35 9.35 0 0 0 2.767 6.674c1.713 1.709 4.085 2.794 6.687 2.794 3.226 0 6.127-2.073 7.84-5.364v4.97h3.294V7.79z",
  clipRule: "evenodd"
})));
export default SvgGotoAdminWhiteYellow;